import { get, globalPut } from "../index";

// Which source files (host .rvt + linked files) the streamed model shows.
// GET returns the live export's documents with their hidden flag; PUT
// stores the hidden set (at least one file must stay visible).
export const getProjectModelDocuments = (projectId) =>
  get(`/projects/${projectId}/model-documents`);

export const setProjectModelSourceFilter = (projectId, hiddenDocumentIds) =>
  globalPut(`/projects/${projectId}/model-source-filter`, { hiddenDocumentIds }, false);

// Model placement: where each Revit file of the model sits (a
// translation, rotation, scale and visibility per file, in the
// project's export unit). Read by every viewer that streams the model
// and by the dialog behind the project card's placement button.
export const getDocumentTransforms = (projectId) =>
  get(`/projects/${projectId}/document-transforms`);

export const setDocumentTransforms = (projectId, entries) =>
  globalPut(`/projects/${projectId}/document-transforms`, { entries }, false);

// Model file companies: which company (the account owner or a partner)
// each model file belongs to. GET lists the project's companies and every
// file with its company and how it was found (manual / label / owner);
// PUT stores the files chosen by hand ({ docName, companyId }).
export const getDocumentPartners = (projectId) =>
  get(`/projects/${projectId}/document-partners`);

export const setDocumentPartners = (projectId, entries) =>
  globalPut(`/projects/${projectId}/document-partners`, { entries }, false);
